import React, { useState } from "react";
import moment from 'moment';

import Table from 'components/Table/Table/controller';
import StarredCellController from 'components/Table/Cells/Starred/controller';
import TextCellController from 'components/Table/Cells/Text/controller';

import SORT_TYPES from 'constants/sortTypes';

import useWindowDimensions from 'hooks/useWindowDimensions';

import { formatter } from 'utils';


const getTableColumns = () => {
    return [
      {
        accessor: 'name',
        Header: 'Name',
        onSort: (data = [], type) => {
            const _data = [...data];
            switch(type) {
                case SORT_TYPES.ASC:
                    _data.sort((a, b) => a.name > b.name)
                    break;
                case SORT_TYPES.DSC:
                    _data.sort((a, b) => a.name < b.name)
                    break;
            }

            return _data;
        },
        Cell: (props) => {
          let linkGenerator;
          const file = props.original;

          if(file.is_dir) {
            linkGenerator = () => {
              return `/folders/${file.id}/listing`
            }
          }
          return (
            <StarredCellController
              id={props.original.id}
              name={props.value}
              isDir={props.original.is_dir}
              isStarred={props.original.starred}
              linkGenerator={linkGenerator}
            />
          )
        }
      }, {
        Header: 'Last Modified',
        id: 'date_modified',
        onSort: (data = [], type) => {
            const _data = [...data];
            switch(type) {
                case SORT_TYPES.ASC:
                    _data.sort((a, b) => moment(a.date_modified).isAfter(b.date_modified))
                    break;
                case SORT_TYPES.DSC:
                    _data.sort((a, b) => moment(a.date_modified).isBefore(b.date_modified))
                    break;
            }

            return _data;
        },
        Cell: (props) => {
          return (
            <TextCellController
              id={props.original.id}
              name={props.value}
            />
          )
        },
        accessor: d => formatter.formatDate(d.date_modified) 
      }, {
        id: 'size', // Required because our accessor is not a string
        Header: 'Size',
        onSort: (data = [], type) => {
            const _data = [...data];
            switch(type) {
                case SORT_TYPES.ASC:
                    _data.sort((a, b) => a.size > b.size)
                    break;
                case SORT_TYPES.DSC:
                    _data.sort((a, b) => a.size < b.size)
                    break;
            }

            return _data;
        },
        Cell: (props) => {
          return (
            <TextCellController
              id={props.original.id}
              name={props.value}
            />
          )
        },
        accessor: d => formatter.memorySizeFormatter(d.size) // Custom value accessors!
      }
    ]
}

const DashboardTable =  (
    {
        commandPressed,
        checkCheckbox,
        data,
        fetchMore,
        loading,
        selections = new Set([]),
        uncheckCheckbox
    }
) => {
    const { height } = useWindowDimensions();

    return (
        <Table
            bodyHeight={height * 0.75}
            columns={getTableColumns()}
            data={data}
            fetchMore={fetchMore}
            loading={loading}
            selections={selections}
            getTableProps={() => {
                return {
                    style: {
                        minWidth: 600
                    }
                }
            }}
            getTrProps={(state, rowInfo, column, instance) => {
                const id = rowInfo && rowInfo.original.id;

                return {
                    onClick: (e, { isSelected }) => {
                        const body = { id }

                        if (!commandPressed) {
                            body.resetSelections = true
                        }

                        if (isSelected) {
                            uncheckCheckbox(body)
                        } else {
                            checkCheckbox(body)
                        }
                    },
                }
            }}
            isLoading={loading}
            keyField="id"
            showPagination={false}
        />
    )
}

export default DashboardTable;